import styled from "styled-components";

export const PayrollWrapper = styled("div")(() => {
  return {
    position: "relative",
    padding: 0,
    display: "grid",
    gap: "1.5rem",
    "& label": {
      fontFamily: "Poppins",
      fontWeight: 600,
      fontSize: "0.8rem",
      color: "var(--color-primary)",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      marginBottom: "0.45rem",
      display: "inline-block",
    },
    "& select, & input": {
      padding: "0.7rem 0.8rem",
      borderRadius: "0.45rem",
      border: "1px solid #d9dee7",
      fontWeight: "400",
      color: "var(--color-text)",
      backgroundColor: "var(--color-neutral)",
      "&:focus": {
        outline: "none",
        border: "none",
      },
    },
    "& select option": {
      backgroundColor: "var(--color-neutral)",
      color: "var(--color-text)",
    },
    "& .form-and-errorbox": {
      border: "1px solid #e5e7eb",
      borderRadius: "0.85rem",
      backgroundColor: "var(--color-primary-hover)",
      padding: "1rem",
      display: "grid",
      gap: ".5rem",
    },
    "& form": {
      display: "grid",
      gap: "1rem",
    },
    "& .payroll-form-grid": {
      display: "grid",
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      gap: "1rem",
      alignItems: "end",
      "@media screen and (max-width: 1024px)": {
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      },
      "@media screen and (max-width: 768px)": {
        gridTemplateColumns: "1fr",
      },
      "& fieldset": {
        display: "flex",
        flexDirection: "column",
        gap: "0.45rem",
        border: "none",
        margin: 0,
        padding: 0,
      },
    },
    "& .payroll-button": {
      backgroundColor: "var(--color-primary)",
      color: "#FFFFFF",
      border: "none",
      borderRadius: "0.45rem",
      fontSize: "0.88rem",
      fontWeight: 600,
      cursor: "pointer",
      padding: "0.7rem 1.2rem",
      transition: "background-color 0.2s ease",
      height: "3rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover": {
        backgroundColor: "#1f5620",
      },
    },
    "& .error-box": {
      display: "grid",
      gap: "1rem",
      "& p": {
        margin: 0,
        color: "#C53A2F",
        fontFamily: "Poppins",
        fontSize: "0.88rem",
        fontWeight: 500,
      },
    },
    "& .filter": {
      border: "1px solid #e5e7eb",
      borderRadius: "0.85rem",
      backgroundColor: "var(--color-primary-hover)",
      padding: "1rem",
      display: "grid",
      gap: "1rem",
    },
    "& .filter-title": {
      margin: 0,
      display: "inline-flex",
      alignItems: "center",
      gap: "0.45rem",
      fontFamily: "Poppins",
      color: "var(--color-text-light)",
      fontSize: "0.78rem",
      letterSpacing: "0.07em",
      textTransform: "uppercase",
      fontWeight: 700,
    },
    "& .filters-grid": {
      display: "grid",
      gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
      gap: "1rem",
      "@media screen and (max-width: 1280px)": {
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      },
      "@media screen and (max-width: 1024px)": {
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      },
      "@media screen and (max-width: 768px)": {
        gridTemplateColumns: "1fr",
      },
      "& fieldset": {
        display: "flex",
        flexDirection: "column",
        gap: "0.45rem",
        border: "none",
        margin: 0,
        padding: 0,
      },
    },
    "& .payroll-table": {
      border: "1px solid #e5e7eb",
      borderRadius: "0.9rem",
      overflowX: "auto",
      backgroundColor: "var(--color-neutral)",
      "& table": {
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: 0,
        minWidth: "950px",
      },
    },
    "& .payroll-table th": {
      backgroundColor: "var(--color-primary-hover)",
      color: "var(--color-primary)",
      borderBottom: "1px solid #e5e7eb",
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      padding: "0.8rem 1rem",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontSize: "0.8rem",
      minWidth: "unset",
      fontWeight: 700,
      textAlign: "left",
    },
    "& .payroll-table tbody": {
      "& tr": {
        borderBottom: "1px solid #e5e7eb",
        "&:last-child": {
          borderBottom: "none",
        },
        "&:hover": {
          backgroundColor: "#FAFAFA",
        },
      },
      "& td": {
        border: "none",
        borderBottom: "1px solid #edf1f6",
        color: "var(--color-text)",
        padding: "0.95rem 1rem",
        minWidth: "unset",
        fontSize: "0.88rem",
        verticalAlign: "middle",
        position: "relative",
      },
    },
    "& .payroll-grid": {
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: 0,
      minWidth: "950px",
      "& th": {
        backgroundColor: "var(--color-primary-hover)",
        color: "var(--color-primary)",
        borderBottom: "1px solid #e5e7eb",
        borderTop: "none",
        borderLeft: "none",
        borderRight: "none",
        padding: "0.8rem 1rem",
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        fontSize: "0.8rem",
        minWidth: "unset",
        fontWeight: 700,
        textAlign: "left",
      },
      "& tbody": {
        "& tr": {
          borderBottom: "1px solid #e5e7eb",
          "&:last-child": {
            borderBottom: "none",
          },
          "&:hover": {
            backgroundColor: "#FAFAFA",
          },
        },
        "& td": {
          border: "none",
          borderBottom: "1px solid #edf1f6",
          color: "var(--color-text)",
          padding: "0.95rem 1rem",
          minWidth: "unset",
          fontSize: "0.88rem",
          verticalAlign: "middle",
          position: "relative",
          "&.action-cell": {
            width: "5%",
            position: "relative",
            textAlign: "center",
            "& .action-trigger": {
              cursor: "pointer",
              padding: "0.5rem",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
            },
            "& .action-dropdown": {
              position: "absolute",
              top: "100%",
              right: 0,
              marginTop: "0.5rem",
              backgroundColor: "var(--color-neutral)",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              minWidth: "150px",
              zIndex: 1000,
              listStyle: "none",
              margin: 0,
              padding: 0,
              overflow: "hidden",
              "& li": {
                padding: "0.75rem 1rem",
                cursor: "pointer",
                fontSize: "14px",
                color: "var(--color-text)",
                transition: "background-color 0.2s ease",
                "&:hover": {
                  backgroundColor: "var(--color-button-secondary-hover)",
                  color: "var(--color-text-light)",
                },
                "&:not(:last-child)": {
                  borderBottom: "1px solid #e5e7eb",
                },
              },
            },
          },
        },
      },
    },
    "& .empty-state": {
      padding: "3rem 1rem",
      textAlign: "center",
      backgroundColor: "#FAFAFA",
      "& h3": {
        margin: "0 0 0.5rem",
        fontSize: "16px",
        fontWeight: 600,
        color: "var(--color-primary)",
      },
      "& p": {
        margin: 0,
        fontSize: "14px",
        color: "var(--color-text)",
      },
    },
    "& .payroll-saveandrun": {
      border: "1px solid #e5e7eb",
      borderRadius: "0.85rem",
      backgroundColor: "var(--color-primary)",
      color: "#FFFFFF",
      padding: "1.2rem 1rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "1rem",
      "@media screen and (max-width: 768px)": {
        flexDirection: "column",
        alignItems: "stretch",
      },
      "& .employee-count": {
        display: "flex",
        flexDirection: "column",
        gap: "0.25rem",
        "& .count-label": {
          fontWeight: 500,
          fontSize: "0.85rem",
          opacity: 0.9,
        },
        "& .count-value": {
          fontWeight: 700,
          fontSize: "1.8rem",
        },
      },
    },
    "& .payroll-cta-box": {
      display: "flex",
      gap: "0.75rem",
      alignItems: "center",
      "@media screen and (max-width: 768px)": {
        width: "100%",
        flexDirection: "column",
        "& button": {
          width: "100%",
        },
      },
      "& button": {
        backgroundColor: "var(--color-neutral)",
        color: "var(--color-text)",
        border: "1px solid #e5e7eb",
        borderRadius: "0.45rem",
        fontSize: "0.88rem",
        fontWeight: 600,
        cursor: "pointer",
        padding: "0.7rem 1.2rem",
        transition: "all 0.2s ease",
        height: "2.75rem",
        width: "fit-content",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover:not(:disabled)": {
          backgroundColor: "#f0f0f0",
        },
        "&:disabled": {
          opacity: 0.5,
          cursor: "not-allowed",
        },
      },
    },
    "& .run-payroll-modal": {
      position: "absolute",
      marginTop: "calc(var(--cardPadding) / 4)",
      zIndex: 10,
      backgroundColor: "var(--color-neutral)",
      borderRadius: "0.45rem",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e5e7eb",
    },
    "& .payment-modal": {
      position: "fixed",
      top: "50%",
      left: "50%",
      height: "auto",
      transform: "translate(-50%, -50%)",
      backgroundColor: "var(--color-neutral)",
      padding: "1rem",
      borderRadius: "0.9rem",
      boxShadow: "0px 20px 24px -4px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e5e7eb",
      "& .payment-form": {
        alignItems: "unset",
        justifyContent: "unset",
        padding: "unset",
      },
      "@media screen and (max-width: 425px)": {
        right: 0,
        bottom: 0,
        borderRadius: "0.9rem",
        border: "none",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "85%",
      },
    },
    "& .payroll-confirmation-modal > div:first-of-type": {
      maxWidth: "19.6rem",
    },
    "& .manage-employee-modal": {
      position: "fixed",
      top: "50%",
      left: "50%",
      height: "auto",
      transform: "translate(-50%, -50%)",
      backgroundColor: "var(--color-neutral)",
      borderRadius: "0.9rem",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e5e7eb",
      "& form": {
        alignItems: "stretch",
        height: "-webkit-fill-available",
      },
      "@media screen and (max-width: 768px)": {
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        right: "0",
        borderRadius: "0.9rem",
        border: "1px solid #e5e7eb",
        width: "85%",
      },
    },
    "& .error-text": {
      color: "#C53A2F",
      fontFamily: "Poppins",
      fontSize: "0.88rem",
      fontWeight: 500,
    },
  };
});
